import React, {FC, ReactNode, useState} from 'react';

import {renderLanguageCode} from '../../../../../../../libs/shared/core/src/helpers/ai/composeV2Helpers';
import {
  AiSupportedLanguageCodesEnum,
  SUPPORTED_LANGUAGE_CODES,
} from '../../../../../../../libs/shared/core/src/helpers/ai/constants';
import {DropdownItem} from '../../../../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItem';
import {DropdownItemCheckbox} from '../../../../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItemCheckbox';
import {DropdownItemContent} from '../../../../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItemContent';
import {DropdownItemIcon} from '../../../../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItemIcon';
import {SearchDropdown} from '../../../../../../../libs/shared/ui/src/components/dropdowns/search/searchDropdown';
import {PopoverTransferProps} from '../../../../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {renderEmojiForLanguageCode} from './helpers';

/*
 * Props.
 */

export interface AiTranslateLanguageDropdownProps {
  dropdownProps: PopoverTransferProps;

  headerTitle: ReactNode;
  selectedLanguages: ReadonlyArray<AiSupportedLanguageCodesEnum>;
  onSelectLanguage: (value: AiSupportedLanguageCodesEnum) => void;
  isMultipleChoices?: boolean;
  disabledLanguages?: ReadonlyArray<AiSupportedLanguageCodesEnum>;

  width?: number;
}

/*
 * Component.
 */

export const AiTranslateLanguageDropdown: FC<AiTranslateLanguageDropdownProps> = ({
  dropdownProps,
  headerTitle,
  selectedLanguages,
  disabledLanguages,
  onSelectLanguage,
  isMultipleChoices,
  width,
}) => {
  const [query, setQuery] = useState('');

  return (
    <SearchDropdown
      {...dropdownProps}
      width={width}
      headerTitle={headerTitle}
      data={SUPPORTED_LANGUAGE_CODES}
      renderRow={(code) => (
        <DropdownItem
          key={code}
          isChecked={selectedLanguages.includes(code)}
          shouldHideCheckmark={isMultipleChoices}
          isDisabled={disabledLanguages?.includes(code)}
          onSelect={(event) => {
            onSelectLanguage(code);
            if (isMultipleChoices) {
              event.preventDefault();
            }
          }}
        >
          <DropdownItemIcon label="">{renderEmojiForLanguageCode(code)}</DropdownItemIcon>
          <DropdownItemContent>{renderLanguageCode(code)}</DropdownItemContent>
          {isMultipleChoices && <DropdownItemCheckbox isChecked={selectedLanguages.includes(code)} />}
        </DropdownItem>
      )}
      query={query}
      onQueryChange={setQuery}
    />
  );
};
